var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuysellArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.8rem",
    height: "0.8rem",
    viewBox: "0 0 24 24",
    className: "icon__Svg-sc-1okz1ct-0 iIbNq asset-searchcss__SortIcon-sc-24z2z9-13 cNhIlh",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "12,24 20,14 4,14"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuysellArrow);
export default __webpack_public_path__ + "static/media/buysell_arrow.2ee8b44bf4d4cb004c678cc55dff59be.svg";
export { ForwardRef as ReactComponent };